import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_TIPOS_ACTIVIDADES_EXTRACUR,
  ALL_TIPOS_ACTIVIDADES_EXTRACUR,
  LOADING_ALL_TIPOS_ACTIVIDADES_EXTRACUR,
} from './TiposActividadesExtcurReducer';
import {
  allTiposActividadesExtcurService,
  deleteTiposActividadesExtcurService,
  oneTiposActividadesExtcurService,
  saveTiposActividadesExtcurService,
} from './TiposActividadesExtcurService';

export const allTiposActividadesExtcurAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_TIPOS_ACTIVIDADES_EXTRACUR, payload: true });
    const res = await allTiposActividadesExtcurService(params);
    dispatch({ type: ALL_TIPOS_ACTIVIDADES_EXTRACUR, payload: res.data });
    dispatch({ type: LOADING_ALL_TIPOS_ACTIVIDADES_EXTRACUR, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_TIPOS_ACTIVIDADES_EXTRACUR, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveTiposActividadesExtcurAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveTiposActividadesExtcurService(id, data);
    notify(res.data.message);
    await allTiposActividadesExtcurAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoTiposActividadesExtcurAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_TIPOS_ACTIVIDADES_EXTRACUR, payload: data });
};

export const oneTiposActividadesExtcurAction = async (dispatch, id) => {
  try {
    const res = await oneTiposActividadesExtcurService(id);
    await setActivoTiposActividadesExtcurAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteTiposActividadesExtcurAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteTiposActividadesExtcurService(id);
    notify(res.data.message);
    await setActivoTiposActividadesExtcurAction(dispatch, null);
    await allTiposActividadesExtcurAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
